import 'react';
import { MoreHorizontal, ChevronRight, ChevronLeft, ChevronsLeft, ChevronsRight } from 'react-feather';
import { jsx } from 'react/jsx-runtime';

const DefaultItem = ({
  page,
  active,
  onClick,
  ...others
}) => {
  const icons = {
    dots: /*#__PURE__*/jsx(MoreHorizontal, {}),
    next: /*#__PURE__*/jsx(ChevronRight, {}),
    prev: /*#__PURE__*/jsx(ChevronLeft, {}),
    first: /*#__PURE__*/jsx(ChevronsLeft, {}),
    last: /*#__PURE__*/jsx(ChevronsRight, {})
  };
  const item = icons[page];
  const children = item || page;
  return /*#__PURE__*/jsx("button", {
    type: "button",
    onClick: onClick,
    "data-active": active ? 'true' : null,
    "aria-current": active ? 'page' : null,
    ...others,
    children: children
  });
};
DefaultItem.displayName = 'DefaultItem';

export { DefaultItem };
